import { render, staticRenderFns } from "./DraftDocument.vue?vue&type=template&id=d5a04b02&"
import script from "./DraftDocument.vue?vue&type=script&lang=js&"
export * from "./DraftDocument.vue?vue&type=script&lang=js&"
import style0 from "./DraftDocument.vue?vue&type=style&index=0&id=d5a04b02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports